import ninjaApi from 'store/redux/apis/ninja.api';

export const billingAddressApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['BillingAddress'],
  endpoints: (builder) => ({
    getBillingAddress: builder.query({
      query: (body) => ({
        url: '/billing/address',
        method: 'GET',
        body,
      }),
      providesTags: ['BillingAddress'],
    }),

    updateBillingAddress: builder.mutation({
      query: (body) => ({
        url: '/billing/address',
        method: 'POST',
        body,
      }),
      providesTags: ['BillingAddress'],
    }),
  }),
});

export const { useGetBillingAddressQuery, useUpdateBillingAddressMutation } = billingAddressApi;
